import React from 'react';
import { motion } from 'framer-motion';
import { Skill } from '../types';

interface SkillBarProps {
  skill: Skill;
  index: number;
}

const SkillBar: React.FC<SkillBarProps> = ({ skill, index }) => {
  // Calculate width based on skill level (1-5)
  const levelWidth = `${(skill.level / 5) * 100}%`;
  
  const getColorByCategory = (category: string): string => {
    switch (category) {
      case 'frontend':
        return 'bg-accent-500';
      case 'backend':
        return 'bg-primary-600';
      case 'design':
        return 'bg-pink-500';
      case 'tools':
        return 'bg-success-500';
      default:
        return 'bg-purple-600';
    }
  };
  
  const barVariants = {
    hidden: { width: 0 },
    visible: (i: number) => ({
      width: levelWidth,
      transition: {
        delay: i * 0.1,
        duration: 0.8,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-1">
        <span className="text-sm font-medium text-white">{skill.name}</span>
        <span className="text-xs text-primary-300">{skill.level}/5</span>
      </div>
      <div className="h-2.5 bg-sky-100 bg-opacity-35 rounded-full overflow-hidden">
        <motion.div
          variants={barVariants}
          initial="hidden"
          animate="visible"
          custom={index}
          className={`h-full rounded-full ${getColorByCategory(skill.category)}`}
        />
      </div>
    </div>
  );
};

export default SkillBar;